import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';

import {ResourcesService} from '../../../../services/resources/resources.service';
import {EventsService} from '../../../../services/events/events.service';

@Component({
  selector: 'modal-general-config',
  styleUrls: [('./modalGeneralConfig.scss')],
  templateUrl: './modalGeneralConfig.html'
})

export class ModalGeneralConfig {

  modalHeader: string;
  generalConfig;

  constructor(
                private activeModal: NgbActiveModal, 
                private _notificationService: NotificationsService,
                private _resourcesService: ResourcesService, 
                private _eventsService: EventsService
             ) {
    this.generalConfig = {
                            id: -1, 
                            codigo: '', 
                            valor: '', 
                            descripcion: ''
                          };
  }

  ngOnInit() {}

  public closeModal() {
    this.activeModal.close();
  }

  private showError(error){
    console.log(error)
    this._notificationService.error('Mensaje', 'Error con los datos ingresados. Verifique el código del parámetro de configuración.');
  }

  private saveGeneralConfig(generalConfig){
    this._eventsService.setObjectCrud(generalConfig);
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalGeneralConfig/modalGeneralConfig.component.ts